import Graph from '@/common/Graph';
import { GraphDataResponse, PeriodType, Point } from '@/common/Graph/types';
import { PortfolioPeriodType } from '@/lib/TradingAccount/types';
import IndividualAssetGraphUtils from './utils';

interface IIndividualAssetGraphProps {
  symbol: string;
  setLatestPrice: (latestPrice: number) => void;
}

export default function IndividualAssetGraph({
  symbol,
  setLatestPrice,
}: IIndividualAssetGraphProps) {
  const { GRAPH_WIDTH, GRAPH_HEIGHT, PERIODS } = IndividualAssetGraphUtils;

  const fetchData = async (
    activePeriodType: PeriodType | PortfolioPeriodType
  ): Promise<GraphDataResponse> => {
    const data = await IndividualAssetGraphUtils.getAggregatePoints(
      symbol,
      activePeriodType as PeriodType
    );
    return data;
  };

  return (
    <Graph
      queryKeyPrefix="individualAssetGraphData"
      symbol={symbol}
      fetchData={fetchData}
      setLatestPrice={setLatestPrice}
      totalWidth={GRAPH_WIDTH}
      totalHeight={GRAPH_HEIGHT}
      periods={PERIODS}
    />
  );
}
